<ol [ngClass]="{'aling_right':aling_right, 'paginator-container':true}">
  <li (click)="navigateToPage(1)" style="font-size: 20px;"><<</li>
  <li (click)="navigateToPage(index - 1)" class="desk-pag"><</li>
  @for (page of pagination.pages; track trackByFn($index)) {
    <li
      class="paginator-number"
      [class.active]="page === pagination.index"
      (click)="navigateToPage(page)"
      [ngClass]="{'paginator-number':true , 'disabled-nav': page > maxPages}"
      >
      @if (page != 0) {
        <span>{{ page }}</span>
      }
    </li>
  }
  <li (click)="navigateToPage(index + 1)" class="desk-pag2">></li>
  <li (click)="navigateToPage(maxPages)" style="font-size: 20px;">>></li>
</ol>
